/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ObjectiveProgress
 */
export interface ObjectiveProgress {
    /**
     * 
     * @type {string}
     * @memberof ObjectiveProgress
     */
    objectiveId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ObjectiveProgress
     */
    isComplete: boolean;
    /**
     * 
     * @type {number}
     * @memberof ObjectiveProgress
     */
    amount: number;
    /**
     * Lifetime high-water mark for streak progress
     * @type {number}
     * @memberof ObjectiveProgress
     */
    bestAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ObjectiveProgress
     */
    sessionAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ObjectiveProgress
     */
    gameId?: string;
    /**
     * Checkpoint thresholds that have been reached
     * @type {Array<number>}
     * @memberof ObjectiveProgress
     */
    completedCheckpoints?: Array<number>;
    /**
     * Checkpoint thresholds whose rewards have been claimed
     * @type {Array<number>}
     * @memberof ObjectiveProgress
     */
    claimedCheckpoints?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ObjectiveProgress
     */
    claimedAt?: number;
}

/**
 * Check if a given object implements the ObjectiveProgress interface.
 */
export function instanceOfObjectiveProgress(value: object): value is ObjectiveProgress {
    if (!('objectiveId' in value) || value['objectiveId'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function ObjectiveProgressFromJSON(json: any): ObjectiveProgress {
    return ObjectiveProgressFromJSONTyped(json, false);
}

export function ObjectiveProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObjectiveProgress {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveId': json['objectiveId'],
        'isComplete': json['isComplete'],
        'amount': json['amount'],
        'bestAmount': json['bestAmount'] == null ? undefined : json['bestAmount'],
        'sessionAmount': json['sessionAmount'] == null ? undefined : json['sessionAmount'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'completedCheckpoints': json['completedCheckpoints'] == null ? undefined : json['completedCheckpoints'],
        'claimedCheckpoints': json['claimedCheckpoints'] == null ? undefined : json['claimedCheckpoints'],
        'claimedAt': json['claimedAt'] == null ? undefined : json['claimedAt'],
    };
}

export function ObjectiveProgressToJSON(json: any): ObjectiveProgress {
    return ObjectiveProgressToJSONTyped(json, false);
}

export function ObjectiveProgressToJSONTyped(value?: ObjectiveProgress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveId': value['objectiveId'],
        'isComplete': value['isComplete'],
        'amount': value['amount'],
        'bestAmount': value['bestAmount'],
        'sessionAmount': value['sessionAmount'],
        'gameId': value['gameId'],
        'completedCheckpoints': value['completedCheckpoints'],
        'claimedCheckpoints': value['claimedCheckpoints'],
        'claimedAt': value['claimedAt'],
    };
}

